import React from 'react';

const PercentWithArrow = ({prev, curr}) => {
  let percent = '';
  if (prev === 0) percent = 'N/A';
  if (prev !== 0){
    percent =  ((curr - prev) / prev * 100).toFixed(2) + '%';
  }
  return (
    <span className={percent === 'N/A' ? 'd-none' : percent.includes('-') ? 'text-danger' : 'text-success'}>
      <i className={percent.includes('-') ? 'fas fa-arrow-down' : 'fas fa-arrow-up'}></i>&nbsp;
      {percent}
    </span>
  );
};

const FindNumberInArray = (label, index, datasets) => {
  const num = datasets.reduce( (prev, curr) =>{
    if (label.includes(curr.label)) return prev + curr.data[index];
    else return prev;
  },0);
  return num;
}

export default function PercentBox({left, right, leftlabel, rightlabel}) {
  let scanAt11L = 0;
  let scanAt10L = 0;
  let scanAt11R = 0;
  let scanAt10R = 0;
  if (left !== undefined){
    //leftlabel === Scan
    scanAt10L = FindNumberInArray(leftlabel, left.datasets[0].data.length - 2, left.datasets);
    scanAt11L = FindNumberInArray(leftlabel, left.datasets[0].data.length - 1, left.datasets);
  }

  if (right !== undefined){
    //leftlabel === Scan
    scanAt10R = FindNumberInArray(rightlabel, right.datasets[0].data.length - 2, right.datasets);
    scanAt11R = FindNumberInArray(rightlabel, right.datasets[0].data.length - 1, right.datasets);
  }

  return (
    <div className="d-flex">
      <p className="d-flex flex-column">
        <PercentWithArrow prev={scanAt10L} curr={scanAt11L}/>
        <span className="text-muted">
          {left !== undefined ? leftlabel : null}
        </span>
      </p>
      <p className="ml-auto d-flex flex-column text-right">
        <PercentWithArrow prev={scanAt10R} curr={scanAt11R}/>
        <span className="text-muted">
          {(right !== undefined) && (rightlabel.length > 1)  ? "Redeem" : ""}
          {(right !== undefined) && (rightlabel.length === 1)  ? rightlabel[0] : ""}
        </span>
      </p>
    </div>
  );
}
